import './Section.scss';

const Section = (props) => {
  const className = `
    mdl-section 
    ${props.container ? 'mdl-section--container' : ''}
    ${props.twoColumn ? 'mdl-section--2-col' : ''}
    ${props.largeGap ? 'mdl-section--large-gap' : ''}
    ${props.marginBottom ? 'mdl-section--margin-bottom' : ''}
    ${props.contentGrid ? 'mdl-section--content-grid' : ''}
    ${props.twoColGrid ? 'mdl-section--two-col-grid' : ''}
    ${props.className ? props.className : ''}
  `;

  return (
    <section className={className}>
      {props.children}
    </section>
  )
}

export default Section;